import type { Account, AccountType } from "./types";

export const DEFAULT_BROKERAGE_NAMES = [
  "松井証券",
  "SBI証券",
  "マネックス証券",
  "岩井コスモ証券",
  "JTG証券",
  "大和証券",
  "野村ネット＆コール",
  "GMOクリック証券",
  "SMBC日興証券",
  "みずほ証券",
  "むさし証券",
  "三菱UFJ eスマート証券",
  "東海東京証券",
  "楽天証券",
  "岡三証券",
  "SBIネオトレード証券",
  "アイザワ証券",
  "大和コネクト証券",
] as const;

export const DEFAULT_BANK_NAMES = ["三井住友銀行", "三菱UFJ銀行"] as const;

export function createDefaultAccounts(at = new Date().toISOString()): Account[] {
  const make = (name: string, type: AccountType, sortOrder: number): Account => ({
    id: crypto.randomUUID(),
    name,
    type,
    openingBalanceYen: 0,
    openingAt: at,
    archived: false,
    sortOrder,
    createdAt: at,
    updatedAt: at,
  });
  return [
    ...DEFAULT_BANK_NAMES.map((name, index) => make(name, "bank", index)),
    ...DEFAULT_BROKERAGE_NAMES.map((name, index) => make(name, "brokerage", index)),
  ];
}
